import { AfterContentInit, Component, ElementRef, Input, ViewChild } from '@angular/core';
import { trigger, style, animate, transition, keyframes } from '@angular/animations';
import { TrackingInfo } from '@evermile/customer-tracking';
import CustomerTrackingStatusEnum = TrackingInfo.CustomerTrackingStatusEnum;
import { EditField } from '@evermile/api';

const growAnimation = trigger('grow', [
  transition('0=>1', [animate('3s', keyframes([style({ transform: 'scale(1)' }), style({ transform: 'scale(2)' })]))]),
]);

@Component({
  selector: 'common-order-address',
  templateUrl: './order-address.component.html',
  styleUrls: ['./order-address.component.scss'],
  animations: [growAnimation],
})
export class OrderAddressComponent implements AfterContentInit {
  @Input() merchantName!: string;
  @Input() customerInstructions?: string | null;
  @Input() senderName?: string;
  @Input() dropoffAddressWasEdited? = false;
  @Input() brandColor!: string;
  @Input() addressLine1!: string;
  @Input() addressLine2?: string;
  @Input() orderStatus!: CustomerTrackingStatusEnum;
  @Input() isExternalPickup?: boolean;
  @ViewChild('merchantNameElement') merchantNameElement!: ElementRef;

  readonly StatusEnum = CustomerTrackingStatusEnum;
  readonly CancelledColor = '#BBC6D6';

  readonly BaseLineHeightRem = 2.3;
  growState = 0;

  encodedColor = encodeURIComponent(this.brandColor);
  lineHeight = this.BaseLineHeightRem;

  ngAfterContentInit() {
    const textLineHeightPx = 16;
    setTimeout(() => {
      if (this.merchantNameElement?.nativeElement?.clientHeight > textLineHeightPx) {
        this.lineHeight =
          this.BaseLineHeightRem + (this.merchantNameElement.nativeElement.clientHeight - textLineHeightPx) / 10;
      }
    }, 100);
  }

  onGrowDone() {
    this.growState = this.growState ? 0 : 1;
  }

  protected readonly EditField = EditField;
}
